import { getLocalizedString } from "@grandvisionhq/utils";
const getLineItemPrice = (priceObj, locale) => {
  const total = priceObj.total;
  const unit = priceObj.unit;
  return {
    total: {
      discount: total.discount.amount,
      original: total.subtotal,
      gross: total.gross,
      net: total.net,
      taxAmount: total.tax.amount,
      taxRate: total.tax.portions[0]?.rate ?? 0
    },
    unit: {
      discount: unit.discount.amount,
      original: unit.subtotal,
      gross: unit.gross,
      net: unit.net,
      taxAmount: unit.tax.amount,
      taxRate: unit.tax.portions[0]?.rate ?? 0,
      appliedDiscounts: unit.discount.appliedDiscounts.map((discountItem) => ({
        type: discountItem.type,
        value: discountItem.amount,
        label: getLocalizedString(discountItem.details?.name, locale)
      }))
    }
  };
};
export {
  getLineItemPrice
};
//# sourceMappingURL=get-line-item-price.js.map
